module.exports = __webpack_public_path__ + "media/photos/term-bg-1-c9813571.jpg";